import React from 'react'
import {Text, View} from '@react-pdf/renderer'
import {IIncomeDocument} from '../IncomeDocumentDetailPage'
import {IncomeDocumentTypes} from '../../../constants/Common'
import {formatBankAccount} from '../../../utils/Helper'

interface IPrintPsSection {
  document: IIncomeDocument
}

const PrintPsSection: React.FC<IPrintPsSection> = (props) => {
  const { document } = props
  const shouldRenderPayment = [IncomeDocumentTypes.DEPOSIT, IncomeDocumentTypes.RECEIPT].includes(document.type)

  const _renderReceiptAndDeposit = () => {
    return (
      <View style={{paddingBottom: '6px'}}>
        <Text>{'1. กรณีโอนเงิน/เงินสด ใบเสร็จรับเงินนี้จะสมบูรณ์ก็ต่อเมื่อได้รับเงินโอน/เงินสดเรียบร้อยแล้ว'}</Text>
        <Text>{'2. กรณีชำระเป็นเช็ค ใบเสร็จรับเงินนี้จะสมบูรณ์ก็ต่อเมื่อได้เรียกเก็บเงินจากธนาคารแล้ว'}</Text>
        <Text>{'3. เอกสารไม่ถูกต้องกรุณาแจ้งแก้ไขภายใน 7 วัน หากพ้นกำหนดแล้วจะไม่รับผิดชอบใดๆ ทั้งสิ้น'}</Text>
      </View>
    )
  }

  const _renderInvoiceAndDebit = () => {
    const bankName = document?.labCompany?.bankName || 'ธ.กสิกรไทย'
    const bankAccountNumber = formatBankAccount(document?.labCompany?.accountNumber || '3521017499')

    return (
      <View style={{paddingBottom: '6px'}}>
        <Text>1. กรณีชำระเงินโดยเช็ค กรุณาขีดคร่อมในนาม “บริษัท แอลดีซี เด็นทัล จำกัด (มหาชน)” เท่านั้น</Text>
        <Text>2. กรณีโอนเงิน โอนเข้าบัญชี บริษัท แอลดีซี เด็นทัล จำกัด (มหาชน) <Text style={{color: '#ff0000'}}>{bankName} เลขที่ {bankAccountNumber}</Text></Text>
      </View>
    )
  }

  const _renderComponent = () => {
    if ([IncomeDocumentTypes.DEPOSIT, IncomeDocumentTypes.RECEIPT].includes(document.type)) {
      return _renderReceiptAndDeposit()
    }

    if ([IncomeDocumentTypes.INVOICE, IncomeDocumentTypes.DEBIT].includes(document.type)) {
      return _renderInvoiceAndDebit()
    }

    return <></>
  }

  return (
    <>
      <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '8px', borderTop: '1px solid #bfbfbf', padding: '8px 0'}}>
        <View style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px', minWidth: '50px'}}>
          <Text style={{fontFamily: 'FontAwesome', fontSize: 9}}>{'\uf4ad'}</Text>
          <Text style={{fontWeight: 'bold'}}>{'หมายเหตุ'}</Text>
        </View>
        <View style={{display: 'flex', flex: 1}}>
          <Text>{document?.note || ''}</Text>
        </View>
      </View>
      {_renderComponent()}
    </>
  )
}

export default PrintPsSection
